export const MARKER_TARGET_WIDTH = 10;
